import React from "react";
import "./Footer.css";

import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";

// import logo from "/images/logo.png";

const Footer = () => {
  return (
    <footer className="tigps-footer">
      <img alt="fef" class="footer-watermark" src="images/logo-bg.png"></img>
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-left">
          <div className="footer-brand">
            <img src="/images/footer-logo.png" alt="TIGPS Logo" />
            <h2>
              Techno India Group
            </h2>
          </div>
          <div>
            <p className="footer-brand-info">With an illustrious journey of more than four decades, Techno India Group has cemented
              its position today in India’s academic map. Beyond academics, it has been making its
              presence strongly felt in an array of areas – healthcare, media, hospitality, sports and
              consultancy. Through our various CSR initiatives, we are constantly contributing to the
              betterment of our society and trying to take care of the planet. ​</p>
          </div>

          <div className="follow-us">
            <p>Follow Us</p>
            <div className="icons">
              <a href="https://www.facebook.com/TechnoIndiaGroupofficialfbpage/" aria-label="Facebook" target="_blank" className="icon facebook">
                <i className="bi bi-facebook"></i>
              </a>

              <a href="https://www.instagram.com/techno.india.group/?igshid=YmMyMTA2M2Y%3D" aria-label="Instagram" target="_blank" className="icon instagram">
                <i className="bi bi-instagram"></i>
              </a>

              <a href="#" aria-label="YouTube" target="_blank" className="icon youtube">
                <i class="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="footer-right">

          {/* Quick Links */}
          <div className="footer-link-sec">
            <div className="footer-links">
              <h3>Affiliations Link</h3>
              <ul>
                <div className="container">
                  <div className="row">
                    <div className="col-md-8">
                      <li><a href="https://www.aicte.gov.in/" target="_blank">AAICTE</a></li>
                      <li><a href="https://www.nbaind.org/" target="_blank">NBA</a></li>
                      <li><a href="https://www.makautexam.net/" target="_blank">MAKAUT</a></li>
                      <li><a href="https://www.ugc.gov.in/" target="_blank">UGC</a></li>
                    </div>
                    <div className="col-md-4">
                      <li><a href="https://nad.gov.in/" target="_blank">NAD</a></li>
                      <li><a href="http://naac.gov.in/index.php/en//" target="_blank">NAAC</a></li>
                      <li><a href="https://wbjeeb.in/" target="_blank">WBJEEB</a></li>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
            <div className="footer-links">
              <h3>Entrance Overview</h3>
              <ul>
                <div className="container">
                  <div className="row">
                    <div className="col-md-8">
                      <li><a href="https://www.nata.in/" target="_blank">NATA</a></li>
                      <li><a href="https://www.aima.in/content/testing-and-assessment/mat/mat" target="_blank">AIMA</a></li>
                      <li><a href="https://iimcat.ac.in/per/g01/pub/756/ASM/WebPortal/1/index.html?756@@1@@1" target="_blank">CAT</a></li>
                      <li><a href="https://wbjeeb.nic.in/WBJEEBBoardCMS/Page/Page?PageId=1&LangId=P/" target="_blank">WBJEE</a></li>
                    </div>
                    <div className="col-md-4">
                      <li><a href="https://wbjeeb.nic.in/EXMJECACMS/Page/Page?PageId=1&LangId=P" target="_blank">JECA</a></li>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
          <div className="footer-link-sec footer-contact">
            <div className="footer-links">
              <h3>Our Offices</h3>
              <div className="footer-location">
                <p>
                  <i class="bi bi-geo-alt-fill"></i>
                  Headquarters: 1/1 Service Rd, DG <br />
                  Block(Newtown), Action Area I, <br />
                  Newtown, Kolkata - 700156, <br />
                  West Bengal
                </p>
                <p>
                  <i class="bi bi-geo-alt-fill"></i>
                  EM-4, Sector-V, Salt Lake, <br />
                  Kolkata-700091,West Bengal
                </p>
              </div>
            </div>
            <div className="footer-links">
              <h3>Get in touch!</h3>
              <div className="footer-contact">
                <p className="firstphone">
                  <i class="bi bi-telephone"></i>
                  <a href="tel:+918013302685">+91 80133 02685</a> <br />
                </p>
                <p className="secondphone">
                  <a href="tel:+918334890202">+91 83348 90202</a>
                </p>
                <p>
                  <i class="bi bi-envelope"></i>
                  <a href="mailto:info@technoindiagroup.in">info@technoindiagroup.in</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        Copyright 2026 technoindiagroup.in - All Rights Reserved. Made by TIG
      </div>
    </footer>
  );
};

export default Footer;
